import ServiceBase from "./service-base";
import IHttpResponse from "src/http/http-response";
import { ServiceInjectable } from "src/utils/services";

/**
 * 城市服务类
 * @class
 * @version 1.0.0
 */
@ServiceInjectable()
export default class CityService extends ServiceBase {

    /**
     * 获取城市列表 
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async getCityList(): Promise<IHttpResponse> {
        let response = await this.apis.getCityList({});
        return response;
    }

}